import { useState, useEffect } from 'react'
import { useApp } from '../components/app-context'

export function useIsProgramRecording(programId: number) {
  const [data, setData] = useState<'once' | 'everyday' | 'none'>('none')
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { isProgramRecording, userRecordings } = useApp()
  useEffect(() => {
    async function load() {
      setIsLoading(true)
      const isRecording = isProgramRecording(programId)
      setData(isRecording)
      setIsLoading(false)
    }
    if (programId) load()
    else {
      // setData(undefined)
      setIsLoading(false)
    }
  }, [userRecordings, programId, isProgramRecording])

  return { data, setData, isLoading }
}
